import { render, staticRenderFns } from "./ModelGeneratorForm.vue?vue&type=template&id=63dc065c&scoped=true&"
import script from "./ModelGeneratorForm.vue?vue&type=script&lang=js&"
export * from "./ModelGeneratorForm.vue?vue&type=script&lang=js&"
import style0 from "./ModelGeneratorForm.vue?vue&type=style&index=0&id=63dc065c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63dc065c",
  null
  
)

export default component.exports